export const MODULE_NAME = 'email-templates';